import React from 'react';
import styles from './ConnectionStatus.module.css';

function ConnectionStatus({ connected, reconnecting }) {
  if (connected) {
    return (
      <div className={styles.status}>
        <span className={styles.indicatorConnected}></span>
        <span className={styles.text}>Verbunden</span>
      </div>
    );
  }

  if (reconnecting) {
    return (
      <div className={styles.status}>
        <span className={styles.indicatorReconnecting}></span>
        <span className={styles.text}>Neu verbinden...</span>
      </div>
    );
  }

  return (
    <div className={styles.status}>
      <span className={styles.indicatorDisconnected}></span>
      <span className={styles.text}>Getrennt</span>
    </div>
  );
}

export default ConnectionStatus;
